var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    ref: "contentRoot",
    staticClass: "tw-report",
    domProps: { innerHTML: _vm._s(_vm.analysisContent) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }